import { isAsyncThunkAction, isPending } from '@reduxjs/toolkit';
import { Dispatch, Middleware, AnyAction } from 'redux';
import isRegExp from 'lodash/isRegExp';

const isWhiteListAction = (action: AnyAction) => {
  const whiteList: Array<string | RegExp> = [
    'asr/stopRealtimeAsr',
    'asr/startRealtimeAsr',
    'trtc/muteMic',
    'trtc/muteMic',
    'trtc/enterRoom',
    'trtc/leaveRoom',
    /^TIM/,
  ];

  const typePrefix = action.type.replace(/\/(pending|fulfilled|rejected)$/, '');

  return (
    isAsyncThunkAction(action) && whiteList.some((api) => (isRegExp(api) ? api.test(typePrefix) : typePrefix === api))
  );
};
const requestIdMap: Record<string, string> = {};
export const freqLimitMiddleware: Middleware<Dispatch> = () => (next) => (action: AnyAction) => {
  if (!isWhiteListAction(action) && isAsyncThunkAction(action)) {
    if (isPending(action)) {
      const typePrefix = action.type.replace(/\/(pending|rejected|fulfilled)$/, '');
      if (typePrefix in requestIdMap) {
        throw new Error(`重复调用: ${typePrefix}`);
      }
      Object.assign(requestIdMap, {
        [typePrefix]: action.meta.requestId,
      });
    } else {
      const name = action.type.replace(/\/(rejected|fulfilled)$/, '');
      if (name in requestIdMap && requestIdMap[name] === action.meta.requestId) {
        delete requestIdMap[name];
      }
    }
  }
  return next(action);
};
